import React, { createContext, useEffect, useMemo, useReducer } from "react";
import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";
import { handleConsoleError } from "../utils/common-methods";
import { toast } from "react-toastify";

export const ChatboatContext = createContext<any>(this);

const LinkifyText = ({ text = "" }) => {
  const urlRegex = /(https?:\/\/|www\.|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})([\w@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/gi;

  const processedText = text.split(urlRegex).map((part, index) => {
    if (urlRegex.test(part)) {
      let url = part.startsWith("http") ? part : `https://${part}`;
      return (
        <a
          key={index}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline"
        >
          {part}
        </a>
      );
    }
    return part;
  });

  return <p>{processedText}</p>;
};

export const ChatboatContextProvider = (props: any) => {
  let chatId = 1;
  const [state, dispatch] = useReducer(
    (prevState: any, action: any) => {
      switch (action.type) {
        case "ON_LOAD_QUESTIONS":
          return {
            ...prevState,
            questions: action?.questions,
          };
        case "ON_LOAD_STEPS":
          return {
            ...prevState,
            stepsDynamic: action?.stepsDynamic,
          };
        case "ON_CHAT_ID_CHANGE":
          return {
            ...prevState,
            chatId: action?.chatId,
          };
      }
    },
    {
      questions: new Array<any>(),
      currentPage: 1,
      pageSize: 5,
      chatId: 1,
      stepsDynamic: [],
    }
  );

  useEffect(() => {
    // Fetch the token from storage then navigate to our appropriate place
    const bootstrapAsync = async () => {
      try {
        const questions = await dataRepository.fetchQuestions();
        await dataRepository.reloadSteps(questions);
      } catch (e) {
        // Restoring token failed
       const message= handleConsoleError(e);
       toast.error((e as any)?.message|| message);
      }
    };

    bootstrapAsync();
  }, []);

  const dataRepository = useMemo(
    () => ({
      /** 
       API function to fetch user accounts.
       */
      fetchQuestions: async () => {
        try {
          const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
          const response = await axioClient.get(
            apiendpoints.GET_CHATBOT_QUESTIONS +
              `?pageNumber=${state.currentPage}&pageSize=${state.pageSize}`
          );
          const res = APICLIENT.handleResponse(response) as any;
          if (res?.isSuccess) {
            dispatch({ type: "ON_LOAD_QUESTIONS", questions: res?.data });
            return res?.data;
          }
          // else{
          //   toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
          // }
        } catch (error) {
         const message= handleConsoleError(error);
          toast.error((error as any)?.message|| message);
        }
        return [];
      },
      reloadSteps: async (questions: [] = []) => {
        var mySteps = [
          {
            id: "1",
            message: "Hello!",
            trigger: "2",
          },
          {
            id: "2",
            options: [] as any,
          },
          {
            id: "3",
            message: "Do you want to continue with other queries?",
            trigger: "4",
          },
          {
            id: "4",
            options: [
              { value: "1", label: "Yes", trigger: "2" },
              { value: "2", label: "No", trigger: "5" },
            ],
          },
          {
            id: "5",
            message:
              "Thank you for chatting with us today! If you have any more questions or need further assistance, feel free to reach out anytime. Have a great day!",
            trigger: "6",
          },
          {
            id: "6",
            component: (
              <div
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={async (e) => {
                  e.stopPropagation();
                  state.currentPage = 1;
                  const questions = await dataRepository.fetchQuestions();
                  await dataRepository.reloadSteps(questions);
                }}
              >
                Start again
              </div>
            ),
            asMessage: true,
          },
        ];
        const options = [];

        questions.forEach((question: any, index: number) => {
          if (options.length === state.pageSize) {
            return;
          }
          options.push({
            value: `${index + 1}`,
            label: question?.question,
            trigger: `${mySteps.length + 1}`,
          });
          // mySteps.push({
          //   id: `${mySteps.length + 1}`,
          //   message: question.answer,
          //   trigger: "3",
          // });
          mySteps.push({
            id: `${mySteps.length + 1}`,
            component: (
              <div
                style={{ color: "white" }}
                dangerouslySetInnerHTML={{ __html: question?.answer }}
              ></div>
            ),
            asMessage: true,
            trigger: "3" as any,
          });
        });
        if (questions.length > 0) {
          options.push({
            id: `${options.length + 1}`,
            label: "Others",
            trigger: async (value: any, steps1: any) => {
              state.currentPage += 1;
              var questions = await dataRepository.fetchQuestions();

              if ((questions ?? []).length === 0 && state.currentPage > 1) {
                state.currentPage = 1;
                questions = await dataRepository.fetchQuestions();
              }
              if (questions) {
                await dataRepository.reloadSteps(questions);
              }

              return false;
            },
          });
        }

        if (questions.length === 0) {
          state.currentPage = 1;
          await dataRepository.fetchQuestions();
        } else {
          mySteps[1].options = options;
        }
        chatId += 1;
        dispatch({ type: "ON_LOAD_STEPS", stepsDynamic: mySteps });
        dispatch({ type: "ON_CHAT_ID_CHANGE", chatId: chatId });
        return mySteps;
      },
    }),
    []
  );

  return (
    <ChatboatContext.Provider value={{ dataRepository, ...state, dispatch }}>
      {props.children}
    </ChatboatContext.Provider>
  );
};
